const grayA = {
  grayA1: "hsla(0, 0%, 0%, 0.012)",
  grayA2: "hsla(0, 0%, 0%, 0.027)",
  grayA3: "hsla(0, 0%, 0%, 0.047)",
  grayA4: "hsla(0, 0%, 0%, 0.071)",
  grayA5: "hsla(0, 0%, 0%, 0.090)",
  grayA6: "hsla(0, 0%, 0%, 0.114)",
  grayA7: "hsla(0, 0%, 0%, 0.141)",
  grayA8: "hsla(0, 0%, 0%, 0.220)",
  grayA9: "hsla(0, 0%, 0%, 0.439)",
  grayA10: "hsla(0, 0%, 0%, 0.478)",
  grayA11: "hsla(0, 0%, 0%, 0.565)",
  grayA12: "hsla(0, 0%, 0%, 0.910)"
};
export { grayA };
//# sourceMappingURL=grayA.mjs.map
